import Header from "../components/Header/Header";
import Overview from "../components/Overview/Overview";
import Banner from "../components/banner/Banner";
import CompanyPartner from "../components/company-partner/CompanyPartner";
import GridCard from "../components/grid-card-section/GridCard";
import Usecase from "../components/tab-switch-section/tabswitch";
import RoiSection from "../components/roi-section/roi";
import FaqSection from "../components/faq-section/FaqSection";
import Midbanner from "../components/mid-banner-section/Midbanner";
import FooterSection from "../components/footer-section/Footer";
export default function AgentGrc() {
    return (
        <>
            <Header />
            <Banner />
            <CompanyPartner />
            <Overview />
            <GridCard />
            <Usecase />
            <RoiSection />
            <FaqSection />
            <Midbanner />
            <FooterSection />
        </>
    );
}
